/**
 * @file: using.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

type Disposable = () => () => void;

export function using(...disposables: Disposable[]) {
  const list = disposables.map(task => task());
  return () => list.forEach(dispose => dispose());
}
